'use strict';

import {ewModel} from './ewmodel.js';
import {timeZoneDate} from '../lib/timezonedate.js';

export class ngDepModel extends ewModel
{
	_services = {
	}

	constructor(itemData, $filter, jsDataService){
		super(itemData);
		this._services.$filter = $filter;
		this._services.jsDataService = jsDataService;
	}

	s(name){
		if(typeof(this._services[name]) !== 'undefined'){
			return this._services[name];
		}
		return null;
	}

	getTitledValue(name){
		if(typeof(this[name + '_title']) !== 'undefined'){
			return this[name + '_title'];
		}
		return '';
	}

	getDisplayValue(name){
		if(typeof(this[name + '_display']) !== 'undefined'){
			return this[name + '_display'];
		}
		return '';
	}

	getOnValue(name){
		if(typeof(this[name + '_on']) !== 'undefined' && (true === this[name + '_on'] || 1 === this[name + '_on'] || '1' === this[name + '_on'])){
			return this[name];
		}
		return '';
	}

	getClassifValue(name, classifName){
		let classif = this.s('jsDataService').get('cfgClassif');
		if(classifName === 'checklist_status' && typeof(classif[classifName]) === 'undefined' && typeof(classif.evaluation_status) !== 'undefined'){
			classifName = 'evaluation_status';
		}
		if(classif && typeof(classif[classifName]) !== 'undefined'){
			if(typeof(this[name]) === 'object' && this[name]){
				let values = [];
				for(let oneVal of Object.values(this[name])){
					let val = this.s('$filter')('filter')(classif[classifName], {id: oneVal}, true);
					if(val.length > 0){
						values.push(val.shift().title);
					}
				}
				if(values.length > 0){
					return values.join(', ');
				}
			}
			else{
				let v = this.s('$filter')('filter')(classif[classifName], {id: this[name]}, true);
				if(v.length > 0){
					return v[0].title;
				}
			}
		}
		return '';
	}

	getClassifOtherValue(name, classifName){
		let value = this.getClassifValue(name, classifName);
		if(arguments[2]){
			if(value !== ''){
				value += ', ';
			}
			value += arguments[2];
		}
		return value;
	}

	getData(){
		let obj = Object.assign({}, angular.copy(this));
		delete obj._services;
		return obj;
	}

	getDateEditZone(){
		const cfgLZ = this._services.jsDataService.get('cfgLocaleZone');
		if(cfgLZ){
			return cfgLZ;
		}
		return {
			dateParams: {
				timeZone: 'CET'
			}
		};
	}

	int2CetDate(timestamp){
		if(isNaN(timestamp)){
			return null;
		}
		return this.cetDate(new Date(parseInt(timestamp)*1000));
	}

	cetDate(dateObj){
		const params = this.getDateEditZone();
		return timeZoneDate(dateObj, params.dateParams.timeZone);
	}

	makeCetField(field){
		const cetField = field + '_cet';
		if(typeof(this[field]) !== 'undefined' && this[field]>0 && !isNaN(this[field])){
			this[cetField] = this.int2CetDate(this[field]);
		}
		else{
			this[cetField] = (arguments[1]) ? new Date() : null;
		}
	}

}
